export default "__VITE_ASSET__ea9093c6__"